import { useMount } from 'react-use';
import { DOM } from '@app/utils';

/**
 *
 */
const useHandleUserSession = () => {
  useMount(() => {
    if (!window.sessionId) {
      return;
    }

    if (!DOM.getCookie('stockx_session')) {
      DOM.setCookie('stockx_session', window.sessionId, {
        maxAge: 3600,
        path: '/',
      });
    }

    // unset sessionId from window obj
    window.sessionId = undefined;
  });
};

export default useHandleUserSession;
